export const ASSIGNABLE_ROLES = ["designer", "videographer", "photographer", "agent"];
export const APPROVER_ROLES = ["admin", "member"];

export const canApprove = (user, order) =>
  APPROVER_ROLES.includes(user?.role) ||
  user?.id === order?.created_by ||
  user?.id === order?.assigned_to;
